import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class SmartOfferBundleDailyPass extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.DAILY_PASS);

        this._reward = null
        this._product = null;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    valid() {
        if (!super.valid()) {
            return false;
        }

        if (!this.reward || this.reward.empty() || !this.reward.valid()) {
            return false;
        }

        if (!this.product || !RedactorUtils.getProduct(this.product)) {
            return false;
        }

        return true;
    }

    empty() {

        if (!this.reward || this.reward.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleDailyPass());
        } else if (target instanceof SmartOfferBundleDailyPass) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleDailyPass, {
    _reward: alias("reward", RewardBunch.schema()),
    _product: alias("product", Schema.primitive())
});
